import React from "react";
import {
  Drawer,
  Typography,
  Flex,
  Card,
  Button,
  Col,
  Switch,
  Row,
  message,
  Collapse,
  Pagination,
} from "antd";
import DimensionsCreateDrawer from "./DimensionsCreateDrawer";
import MessageTextIcon from "../../../../../../../Theme/CustomIcons/Icons/Emails,Messages/MessageTextIcon";
import ArrowCircleRight2Icon from "../../../../../../../Theme/CustomIcons/Icons/Arrow/ArrowCircleRight2Icon";
import { useDispatch, useSelector } from "react-redux";
import PeopleIcon from "../../../../../../../Theme/CustomIcons/Icons/Users/PeopleIcon";
import FlagIcon from "../../../../../../../Theme/CustomIcons/Icons/Essetional/FlagIcon";
import CalendarTickIcon from "../../../../../../../Theme/CustomIcons/Icons/Users/CalendarTickIcon";
import DimensionDetailsDrawer from "./DimensionDetailsDrawer";
import CustomLoaderIcon from "../../../../../../../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";
import MoreEmptyState from "../../../../../../../Theme/EmptyStates/MoreEmptyStates/MoreEmptyState";
import EntityHierarchy from "./EntityHierarchy";
import {
  getAllDimensionsByEntity,
  getSingleDimensionAction,
  setStatusActiveDimension,
} from "../../../../../../../store/action/admin/dimensionsEntityActions";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../../../../../utils/dateFormatUtils";
import HierarchyIcon from "../../../../../../../Theme/CustomIcons/Icons/CustomIcons/HierarchyIcon";

const { Text } = Typography;

// Helper function to transform dimension type for display
const getDisplayDimensionType = (dimensionType) => {
  if (!dimensionType) return "-";
  const normalized = dimensionType.toLowerCase().trim();
  if (normalized === "client") {
    return "Customer";
  }
  // Capitalize first letter of each word
  return dimensionType
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const DimensioneDrawerListingParent = ({
  open,
  onClose,
  title = "Dimensions",
}) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  const isLightBg = themeDefault?.info?.themeColor === "default";
  const [isDimensionsDrawerOpen, setIsDimensionsDrawerOpen] =
    React.useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = React.useState(false);
  const [isHierarchyOpen, setIsHierarchyOpen] = React.useState(false);
  const [selectedType, setSelectedType] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const dispatch = useDispatch();

  const entityId = useSelector((state) => state.getSingleEntityList?.info?._id);
  const getAllDimensionList = useSelector((state) => state.getAllDimensionList);
  React.useEffect(() => {
    if (open && entityId) {
      dispatch(getAllDimensionsByEntity(currentPage, pageSize, entityId));
    }
  }, [open, entityId, currentPage, pageSize]);

  const loading = getAllDimensionList?.loading;
  const dimensionsData = getAllDimensionList?.info || {};
  const dimensions =
    dimensionsData?.data ||
    (Array.isArray(dimensionsData) ? dimensionsData : []);
  // Pagination info from API
  const paginationInfo = getAllDimensionList?.info?.pagination || {};
  const currentPageFromApi = paginationInfo.currentPage || 1;
  const pageSizeFromApi = paginationInfo.limit || 10;
  const total = paginationInfo.total || 0;

console.log({ currentPageFromApi, total, dimensionsData });

  // Update state when API returns new pagination
  // Remove this effect completely or only set page on first load
  React.useEffect(() => {
    if (currentPage === 1 && pageSize === 10) {
      // only on initial load
      setCurrentPage(currentPageFromApi);
      setPageSize(pageSizeFromApi);
    }
  }, [currentPageFromApi, pageSizeFromApi]);

  // Group only the paginated dimensions
  const groupedDimensions = React.useMemo(() => {
    const grouped = {};
    dimensions.forEach((dimensionItem) => {
      const type = dimensionItem?.dimension?.dimension_type || "Other";
      if (!grouped[type]) grouped[type] = [];
      grouped[type].push(dimensionItem);
    });
    return grouped;
  }, [dimensions]);

  // Get status for switch
  const getSwitchStatus = (status) => {
    return status === "Active" || status === "enabled";
  };

  const handleToggleStatus = async (dimension, checked) => {
    if (!dimension?._id) return;
    const nextStatus = checked ? "Active" : "Archived";
    try {
      await dispatch(
        setStatusActiveDimension(dimension._id, { status: nextStatus })
      );
      message.success(`Status updated to ${nextStatus}`);
      if (entityId) {
        await dispatch(
          getAllDimensionsByEntity(currentPage, pageSize, entityId)
        );
      }
    } catch (err) {
      console.error("Failed to update dimension status:", err);
      message.error(err?.message || "Failed to update status");
    }
  };

  const handleCloseDimensionsDrawer = () => {
    setIsDimensionsDrawerOpen(false);
    refetchDimensions();
  };

  const handleOpenDetails = async (dimension) => {
    if (!dimension?._id) {
      message.error("Invalid dimension data");
      return;
    }

    try {
      setSelectedType(dimension.dimension_type || "-");
      await dispatch(getSingleDimensionAction(dimension._id));
      setIsDetailsOpen(true);
    } catch (err) {
      console.error("Failed to fetch dimension details:", err);
      message.error(err?.message || "Failed to load dimension details");
    }
  };

  const handleCloseDetails = () => {
    setIsDetailsOpen(false);
    setSelectedType(null);
  };

  const refetchDimensions = async () => {
    if (entityId) {
      try {
        await dispatch(
          getAllDimensionsByEntity(currentPage, pageSize, entityId)
        );
      } catch (err) {
        console.error("Failed to refetch dimensions:", err);
      }
    }
  };
  const handlePageChange = (page, size) => {
    if (size !== pageSize) {
      setPageSize(size);
      setCurrentPage(1);
    } else {
      setCurrentPage(page);
    }
    dispatch(getAllDimensionsByEntity(page, size || pageSize, entityId));
  };

  // Render dimension card
  const renderDimensionCard = (dimensionItem, index) => {
    const dimension = dimensionItem?.dimension || {};
    const setting = dimensionItem?.setting || {};
    const entity = dimensionItem?.entity || {};
    return (
      <Col span={8} key={dimension._id || index}>
        <Card
          style={{
            padding: "16px 16px 4px 16px",
          }}
          title={
            <Flex
              align="center"
              justify="space-between"
              style={{
                borderBottom: themeDefault?.info?.newConfig?.cardborder,
                width: "100%",
                paddingBottom: 8,
              }}>
              {/* Left side: name + type stacked vertically */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span>{setting.name || "-"}</span>
                <span style={{ fontSize: 10, color: "#A8A8A8" }}>
                  {getDisplayDimensionType(dimension.dimension_type)}
                </span>
              </div>

              {/* Right side: switch */}
              <Switch
                checked={getSwitchStatus(dimension.status)}
                onChange={(checked) => handleToggleStatus(dimension, checked)}
              />
            </Flex>
          }>
          <Flex align="center" justify="space-between">
            <Flex vertical gap={8}>
              <Text>
                <CalendarTickIcon size="small" />{" "}
                {dimensionItem.stats?.totalSameTypeDimensions ?? "-"}{" "}
                {getDisplayDimensionType(dimension.dimension_type)}
              </Text>
              <Text>
                <FlagIcon size="small" />{" "}
                {setting.country || entity.country || "-"}
              </Text>
            </Flex>
            <Flex vertical gap={8}>
              <Text>
                <PeopleIcon size="small" />{" "}
                {dimensionItem.stats?.totalUsers ?? "-"} Users
              </Text>
              <Text>
                <CalendarTickIcon size="small" /> Created on{" "}
                {dimension.created_at
                  ? dayjs(dimension.created_at).format(DATE_FORMAT)
                  : "-"}
              </Text>
            </Flex>
          </Flex>
          <Flex
            align="center"
            justify="space-between"
            style={{
              width: "100%",
              marginTop: 8,
              borderTop: themeDefault?.info?.newConfig?.cardborder,
            }}>
            <Button
              type="link"
              size="small"
              onClick={() => console.log("Comments Button clicked")}
              style={{
                color: `${isLightBg ? "#000000" : "#ffffff"}`,
                width: "50%",
                border: "none",
                fontSize: 12,
              }}>
              <MessageTextIcon size="small" />
              Comments
            </Button>
            {/* separator line */}
            <span
              style={{
                display: "inline-block",
                width: "1px",
                height: "20px",
                backgroundColor: isLightBg ? "#ccc" : "#666",
                margin: "0 4px",
              }}
            />
            <Button
              type="link"
              size="small"
              onClick={() => handleOpenDetails(dimension)}
              style={{
                border: "none",
                color: `${isLightBg ? "#000000" : "#ffffff"}`,
                width: "50%",
                fontSize: 12,
              }}>
              <ArrowCircleRight2Icon size="small" />
              Details
            </Button>
          </Flex>
        </Card>
      </Col>
    );
  };

  return (
    <Drawer
      title={"Dimensions / Overview"}
      placement="right"
      onClose={onClose}
      open={open}
      width="100%">
      <Card
        title={
          <Flex
            align="center"
            justify="space-between"
            style={{
              borderBottom: themeDefault?.info?.newConfig?.cardborder,
              width: "100%",
              paddingBottom: 8,
            }}>
            <span>Dimensions</span>

            <Flex align="center" gap={8}>
              <Button
                type="default"
                onClick={async () => {
                  // If we have dimensions, load the first one for hierarchy view
                  if (dimensions.length > 0) {
                    const firstDimension = dimensions[0]?.dimension;
                    if (firstDimension?._id) {
                      try {
                        await dispatch(
                          getSingleDimensionAction(firstDimension._id)
                        );
                        setIsHierarchyOpen(true);
                      } catch (err) {
                        console.error("Failed to load dimension:", err);
                        message.error("Failed to load dimension hierarchy");
                      }
                    } else {
                      setIsHierarchyOpen(true);
                    }
                  } else {
                    message.warning(
                      "No dimensions available. Please create a dimension first."
                    );
                  }
                }}>
                <HierarchyIcon size="small" />
                Hierarchy
              </Button>
              <Button
                type="primary"
                onClick={() => setIsDimensionsDrawerOpen(true)}>
                Create New Dimension
              </Button>
            </Flex>
          </Flex>
        }>
        {loading ? (
          <Flex align="center" justify="center">
            <CustomLoaderIcon />
          </Flex>
        ) : dimensions.length === 0 ? (
          <Flex align="center" justify="center" style={{ padding: 24 }}>
            <MoreEmptyState
              type="ErrorState"
              size="small"
              text="Create your first dimension to get started"
            />
          </Flex>
        ) : (
          <>
            <Collapse
              items={Object.keys(groupedDimensions).map((type) => ({
                key: type,
                label: (
                  <span
                    style={{
                      fontWeight: 500,
                    }}>
                    {getDisplayDimensionType(type)} (
                    {groupedDimensions[type].length})
                  </span>
                ),
                children: (
                  <Row gutter={[16, 16]}>
                    {groupedDimensions[type].map((dimensionItem, index) =>
                      renderDimensionCard(dimensionItem, index)
                    )}
                  </Row>
                ),
              }))}
            />
            <Flex justify="center" style={{ marginTop: 24 }}>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={total}
                showSizeChanger
                pageSizeOptions={[10, 20, 50, 100]}
                onChange={handlePageChange}
              />
            </Flex>
          </>
        )}
      </Card>
      <DimensionsCreateDrawer
        open={isDimensionsDrawerOpen}
        onClose={handleCloseDimensionsDrawer}
      />
      <DimensionDetailsDrawer
        open={isDetailsOpen}
        onClose={handleCloseDetails}
        type={selectedType}
      />
      <Drawer
        title="Entity Hierarchy"
        placement="right"
        onClose={() => setIsHierarchyOpen(false)}
        open={isHierarchyOpen}
        width="100%"
        destroyOnClose>
        <EntityHierarchy />
      </Drawer>
    </Drawer>
  );
};

export default DimensioneDrawerListingParent;
